<template>
    <div class="contain_box">
      <div class="operatingData">
        <div class="header">
          <div class="title">收入总览</div>
          <div class="left">
            <div class="background">
              <span :class="[{'item':isLive==1}]" @click="changeLive(1)">近30日</span>
              <span :class="[{'item':isLive==2}]" @click="changeLive(2)">近7日</span>
            </div>
          </div>
        </div>
        <div class="income_view">
          <div class="income_item">
            <div>总收入(元)</div>
            <div class="value">141.40</div>
            <div class="changeValue">+141.26</div>
          </div>
          <div class="income_item">
            <div>昨日收入(元)</div>
            <div class="value">0.00</div>
          </div>
        </div>
        <div class="source_box">
          <div class="source">
            <span class="name">渠道</span>
            <span class="all active_All">全部</span>
            <span class="all">电商带货</span>
          </div>
          <div class="source">
            <span class="name">行业</span>
            <span class="all active_All">全部</span>
            <span class="all">其他</span>
          </div>
        </div>
        <div class="flowEachrts" ref="audiencePreferenceRef"></div>
      </div>
      <div class="operatingData">
        <div class="header">
          <div class="title">变现渠道</div>
        </div>
        <div class="tip">近30日你变现最多的渠道</div>
        <div class="realizationChannel" ref="channelEchartsRef"></div>
        <div class="tip_box">
          <div class="left">
            <div style="color: #161722;">你在小程序推广计划等渠道有更大变现潜力</div>
            <div style="color: #717278;">我们为你提供了这些渠道的提升建议</div>
          </div>
          <div class="right" style="color: #1d4788;">去提升</div>
        </div>
      </div>
      <div class="operatingData">
        <div class="header">
          <div class="title">变现行业</div>
        </div>
        <div class="tip">近30日你变现最多的行业</div>
        <div class="realizationChannel" ref="industryEchartsRef"></div>
      </div>
      <div class="operatingData">
        <div class="header">
          <div class="title">商业能力</div>
        </div>
        <div class="tip">帮你提升对品牌客户吸引力</div>
        <div class="box">粉丝达到10万后可开启</div>
      </div>
      <div class="view_more">
        查看更多变现方式<i class="el-icon-arrow-right"></i>
      </div>
    </div>
  </template>
    
  <script>
  import {
    incomeView,
    realizationChannel,
    liquidationIndustry,
  } from "./js/Operatingdata";
  export default {
    data() {
      return {
        isLive: 2,
      };
    },
    props: {},
    mounted() {
      this.getAudienceEcharts();
      this.getChannelEchartsRef(1);
      this.getChannelEchartsRef(2);
    },
  
    methods: {
      getAudienceEcharts() {
        const today = new Date();
        // 生成近七日的日期数组，按从小到大排列
        const dates = [];
        for (let i = 6; i >= 0; i--) {
          const date = new Date(today);
          date.setDate(today.getDate() - i);
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");
          dates.push(`${month}-${day}`);
          let chart = this.$echarts.init(this.$refs.audiencePreferenceRef);
          var xData = dates;
          var y1Data = incomeView.y1Data;
          var y2Data = incomeView.y2Data;
          let option = {
            tooltip: {
              trigger: "axis",
              backgroundColor: "#ffffff", // 设置提示框背景颜色为白色
              textStyle: {
                color: "#666", // 设置提示框文字颜色为黑色，以保证在白色背景下可见
              },
              axisPointer: {
                type: "cross",
                crossStyle: {
                  color: "#999",
                },
              },
            },
            legend: {
              show: true, // 显示图例
              icon: "circle", // 设置图例图标为小圆圈
              itemWidth: 8, // 设置图例图标宽度，调小图标大小
              itemHeight: 8, // 设置图例图标高度，调小图标大小
              textStyle: {
                color: "#333", // 图例文字颜色
                fontSize: 12, // 调小图例文字字体大小
              },
              bottom: 10,
              left: "center",
            },
            grid: {
              top: 20,
              left: 30,
              right: 10,
            },
            xAxis: {
              type: "category",
              data: xData,
              axisTick: {
                show: false, // 不显示 x 轴刻度线
              },
              axisLabel: {
                color: "#b3b3b7", // x 轴字体颜色
              },
              axisLine: {
                show: true, // 不显示 x 轴轴线
                lineStyle: {
                  color: "#b3b3b7",
                },
              },
            },
            yAxis: [
              {
                axisLine: {
                  show: false,
                },
                splitLine: {
                  show: true, // 隐藏 y 轴的分隔线
                  lineStyle: {
                    color: "#F2F2F4", // 设置轴线颜色为红色
                    type: "dashed", // 设置轴线为虚线
                  },
                },
                axisTick: {
                  show: false,
                },
                axisLabel: {
                  show: true,
                  color: "#75767c",
                  formatter: function (value) {
                    return value;
                  },
                },
              },
              {
                type: "value",
                show: false, // 不显示 y 轴
              },
            ],
            series: [
              {
                name: "我",
                type: "line",
                data: y1Data,
                yAxisIndex: 0, // 使用第一个 Y 轴
                itemStyle: {
                  color: "#577cf7", // 折线颜色
                },
                lineStyle: {
                  color: "#577cf7", // 折线颜色
                },
              },
              {
                name: "同类作者",
                type: "line",
                data: y2Data,
                yAxisIndex: 1, // 使用第二个 Y 轴
                itemStyle: {
                  color: "#f0925a", // 折线颜色
                },
                lineStyle: {
                  color: "#f0925a", // 折线颜色
                },
              },
            ],
          };
          chart.setOption(option);
          window.onresize = () => {
            // 基础数据
            chart.resize();
          };
        }
      },
      getChannelEchartsRef(type) {
        let chart = null;
        var xData = [];
        var y1Data = [];
        var y2Data = [];
        // 定义数据
        if (type == 1) {
          chart = this.$echarts.init(this.$refs.channelEchartsRef);
          xData = realizationChannel.xData;
          y1Data = realizationChannel.y1Data;
          y2Data = realizationChannel.y2Data;
        } else {
          chart = this.$echarts.init(this.$refs.industryEchartsRef);
          xData = liquidationIndustry.xData;
          y1Data = liquidationIndustry.y1Data;
          y2Data = liquidationIndustry.y2Data;
        }
  
        // 为 xData 添加索引顺序
        var newXData = xData.map((item, index) => `${index + 1}. ${item}`);
        let option = {
          // 切换为水平柱状图
          tooltip: {
            trigger: "axis",
            backgroundColor: "#ffffff", // 设置提示框背景颜色为白色
            textStyle: {
              color: "#666", // 设置提示框文字颜色为黑色，以保证在白色背景下可见
            },
            axisPointer: {
              // type: "cross",
              crossStyle: {
                color: "#999",
              },
            },
          },
          xAxis: {
            type: "value",
            axisLine: {
              show: false,
            },
            splitLine: {
              show: true, // 隐藏 y 轴的分隔线
              lineStyle: {
                color: "#F2F2F4", // 设置轴线颜色为红色
                type: "dashed", // 设置轴线为虚线
              },
            },
            axisTick: {
              show: false, // 隐藏 x 轴的刻度线（即坐标文字旁的小竖线）
            },
          },
          grid: {
            top: 20,
            left: 70,
            right: 10,
          },
          yAxis: {
            type: "category",
            data: newXData,
            inverse: true,
            axisLabel: {
              color: "#666",
              // 文本水平显示
              rotate: 0,
              // 超出一定长度显示省略号
              formatter: function (value) {
                if (value.length > 10) {
                  return value.slice(0, 10) + "...";
                }
                return value;
              },
              align: "left",
              margin: 70,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#F2F2F4", // 设置轴线颜色为红色
                type: "dashed", // 设置轴线为虚线
              },
            },
          },
          series: [
            {
              name: "我",
              type: "bar",
              data: y1Data,
              itemStyle: {
                color: "#577cf7",
              },
            },
            {
              name: "同类作者",
              type: "bar",
              data: y2Data,
              itemStyle: {
                color: "#f0925a",
              },
            },
          ],
        };
        chart.setOption(option);
        window.onresize = () => {
          // 基础数据
          chart.resize();
        };
      },
    },
  };
  </script>
    
    <style scoped lang="scss">
  .contain_box {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    background: #f5f5f5;
    overflow-y: auto;
    height: 500px;
    // padding-top: 46px;
    box-sizing: border-box;
    scrollbar-width: none;
    -ms-overflow-style: none;
    scrollbar-width: none;
    .operatingData {
      width: 100%;
      padding: 20px 10px;
      background: #fff;
      box-sizing: border-box;
      border-radius: 4px;
      margin-top: 10px;
      .header {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        .title {
          font-weight: 700;
          font-size: 16px;
        }
        .left {
          .background {
            background: #f2f2f2;
            padding: 4px 6px;
            border-radius: 2px;
            font-size: 12px;
            .item {
              background: #fff;
              padding: 2px 3px;
            }
            span {
              margin-right: 5px;
              border-radius: 2px;
              padding: 2px 3px;
            }
          }
        }
      }
      .tip {
        color: #999;
        font-size: 12px;
        margin-top: 5px;
      }
      .income_view {
        display: flex;
        padding: 20px 0;
        border-bottom: 1px solid #e9e9ea;
        .income_item {
          width: 50%;
          .value {
            font-size: 18px;
            font-weight: 600;
            padding: 5px 0;
          }
          .changeValue {
            color: #ea4b35;
          }
        }
      }
      .source_box {
        padding: 10px 0;
        .source {
          padding: 5px 0;
          display: flex;
          align-items: center;
          span {
            display: inline-block;
          }
          .name {
            color: #75767c;
            margin-right: 10px;
          }
          .all {
            padding: 6px 10px;
            border-radius: 13px;
            background: #f3f3f3;
            margin-right: 10px;
            color: #6f7077;
          }
          .active_All {
            color: #161722;
          }
        }
      }
      .flowEachrts {
        width: 100%;
        height: 200px;
      }
      .realizationChannel {
        width: 100%;
        height: 300px;
      }
      .tip_box {
        width: 100%;
        padding: 10px;
        box-sizing: border-box;
        background: #fafafa;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
      }
      .box {
        width: 100%;
        height: 140px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #77787e;
      }
    }
    .view_more {
      margin: 20px 0;
      width: 100%;
      background: #fff;
      border-radius: 4px;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 600;
      font-size: 15px;
      .el-icon-arrow-right {
        color: #333;
        font-weight: 600;
        font-size: 18px;
        margin-top: 2px;
      }
    }
  }
  </style>
    